import StorageServices from "../services/storageServices";

export default function useSellerStore() {
  const store = StorageServices.get("active-sellers-store");
  return JSON.parse(store);
}
